function createOptions () {
    const options = {};

    options.targetElementClassName = 'relatedContentSpotlight';
    options.cacheRequests = JSON.parse(true);
    options.async = JSON.parse(true);
    options.debug = JSON.parse(false);
    options.heading = '';
    options.showHeading = JSON.parse(false);
    options.maxTitleLength = 128;
    options.maxDescriptionLength = 72;
    options.maxSummaryLength = 50;
    options.collections = 'entire_site';
    options.fields = ['thumbnail', 'title_en', 'url', 'call_to_action'];
    options.rows = 1;
    options.startAt = 1;
    options.serviceUrl = '/searchresults/condensed/related/content/en/v1';
    options.unHideIds = ['staticSpotlight'];

    const targetElement = document.getElementById(options.targetElementClassName);
    if (targetElement) {
        options.text = targetElement.getAttribute('addonTitle') + ' ' +
                       targetElement.getAttribute('addonSummary') + ' ' +
                       targetElement.getAttribute('addonTags');
    }

    options.filters = ['(subcollection:offers)'];

    options.itemTemplate = "<div class=\"panel panel-default add_cursor_pointer\" onclick=\"location.href='{{url}}';\">" +
                            '<div class="panel-heading add_padding_0"><img class="fluid_image" src="{{thumbnail}}" title="{{title_en}}" alt="{{title_en}}"></div>' +
                            '<div class="panel-body">' +
                            '<h3>{{title_en}}</h3>' +
                            '<p><a href="{{url}}" class="icon-chevron">{{call_to_action}}</a></p>' +
                            '</div>' +
                            '</div>';

    options.tracking = callbackFunctionForTrackingCode;

    function callbackFunctionForTrackingCode (url) {
        const targetElement = document.getElementById(options.targetElementClassName);
        const addonPath = targetElement ? targetElement.getAttribute('addonPath') : '';
        const regex = /(?!.*\/).+(?=\.)/;
        const match = regex.exec(url);
        const trackingCode = 's_iid=' + ['fx_' + addonPath + '_rcspot'];

        if (url.indexOf('?') > -1) {
            return url + '&' + trackingCode;
        } else {
            return url + '?' + trackingCode;
        }
    }

    if (typeof mwCondensedRelatedContentLib !== 'undefined') {
        mwCondensedRelatedContentLib.init(options);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    createOptions();
});
